import baseApi from "./baseApi"

export default {
    async getDepartmentCodeRates(departmentCodeID){
        const request = await baseApi.createHttpRequest();
        const result = await request.get(`/departmentcodes/rates?departmentCodeID=${departmentCodeID}`);
        return result.data;
    },
    async saveDepartmentCodeRates(rates){
        const request = await baseApi.createHttpRequest();
        const result = await request.post("/departmentcodes/rates", rates);
        return result.data;
    },
    async getDepartmentCodeMaxRate(departmentCodeID){
        const request = await baseApi.createHttpRequest();
        const result = await request.get(`/departmentcodes/rates/${departmentCodeID}/maxPayRate`);
        return result.data;
    }
}